<template>
    <DropdownSelect
        caption="matrix.choose_race"
        :icon="featureIcons.RACES"
        :data="races"
        v-model="raceID"
    />
</template>
<script setup lang="ts">
import { DropdownSelect } from '@/components';
import { featureIcons } from '@/components/Menu/featureicons';
import { useEventCommonStore, useEventCommonStoreRef } from '@/stores';
import { computed } from 'vue';

const raceID = defineModel<number | null>({
    required: true,
});

// Selectable races
const races = computed(() => Array.from(useEventCommonStoreRef().RacesAsSelectLine.value.values()));
</script>
